import { render, staticRenderFns } from "./fbaQuotation.vue?vue&type=template&id=451e54a9&scoped=true&"
import script from "./fbaQuotation.vue?vue&type=script&lang=js&"
export * from "./fbaQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e54a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451e54a9')) {
      api.createRecord('451e54a9', component.options)
    } else {
      api.reload('451e54a9', component.options)
    }
    module.hot.accept("./fbaQuotation.vue?vue&type=template&id=451e54a9&scoped=true&", function () {
      api.rerender('451e54a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/fbaQuotation.vue"
export default component.exports